(function(window, $){

  const $overlay = $('.staff__overlay__container');
  const $overlayImage = $('.leadership__staff__display__image img');
  const $overlayName = $('.leadership__staff__display__name');
  const $overlayPosition = $('.leadership__staff__display__position');
  const $overlayBio = $('.leadership__staff__display__bio');
  const $close = $('.staff__overlay__close, .staff__overlay');

  $close.on('click', handleCloseClick);
  $('.leadership__staff__member__bio-trigger').on('click', handleBioClick);

  function handleBioClick(evt){
    evt.preventDefault();
    const $parentElem = $(this).parents('.leadership__staff__member');
    $overlayImage.attr('src', $parentElem.data('image'));
    $overlayName.html($parentElem.data('name'));
    $overlayPosition.html($parentElem.data('position'));
    $overlayBio.html($parentElem.data('bio'));
    $overlay.addClass('staff__overlay__container--visible');
  }

  function handleCloseClick(){
    $('.staff__overlay__container--visible').removeClass('staff__overlay__container--visible');
  }

})(window, jQuery);